import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line no-unused-vars
import {jquery} from './Globals';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap';
import './static/style.css';

import Layout from './Layout';


ReactDOM.render(<Layout/>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js